module.exports = __webpack_public_path__ + "static/media/35-7.9e4cde2b.mp3";